import { authResetPasswordError, authResetPasswordSuccess } from '@store/slices/auth/authSlice.js';
import httpClient from '@utils/httpClient';
import { call, put } from 'redux-saga/effects';

function resetPasswordApiCall({ email }) {
  return httpClient.post(`api/account/SendForgotPasswordEmail?username=${email}`, {});
}

export function* resetPasswordRequestSaga({ payload: email }) {
  try {
    yield call(resetPasswordApiCall, { email });
    yield put(authResetPasswordSuccess());
  } catch (error) {
    yield put(authResetPasswordError(error.Message ? error.Message : error.toString()));
  }
}
